<div class="margin-y-1" *ngIf="efastIsShown">
  <!-- count {{this.efastHits.found}} countlist {{countList.length}} -->
    <button  *ngFor="let count of countList" class="usa-button margin-top-1 {{isactive(count)}}" type="submit" (click)='pageSelected(count)'>{{count/recordsMax + 1}}</button>
</div>
